// Helpers to compute trial state on the client. The backend is the source of
// truth via `user.has_full_access`, but we use these to render the banner copy.

export function trialDaysLeft(user) {
  if (!user?.trial_ends_at) return 0;
  const ends = new Date(user.trial_ends_at).getTime();
  if (Number.isNaN(ends)) return 0;
  const ms = ends - Date.now();
  if (ms <= 0) return 0;
  return Math.ceil(ms / (1000 * 60 * 60 * 24));
}

export function isTrialActive(user) {
  return Boolean(user) && user.trial_status === "active" && trialDaysLeft(user) > 0 && !user.is_subscribed;
}

export function isTrialExpired(user) {
  return Boolean(user) && !user.is_subscribed && !user.has_full_access;
}
